import React from "react";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { Typography, IconButton, Avatar, ListItemAvatar, ListItemText, AppBar, ListItem, Badge, ListItemSecondaryAction, Button } from "@material-ui/core";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import SendIcon from "@material-ui/icons/Send";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import { isTheSameMinute } from "../../../../helpers/time.helper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import Tooltip from "@material-ui/core/Tooltip";
import QuestionAnswerTwoToneIcon from "@material-ui/icons/QuestionAnswerTwoTone";
import EventLabel2, { renderText } from "../../../../components/EventLabel2/EventLabel2";
import CloseTwoToneIcon from "@material-ui/icons/CloseTwoTone";
import VideocamTwoToneIcon from "@material-ui/icons/VideocamTwoTone";
import VideocamOffTwoToneIcon from "@material-ui/icons/VideocamOffTwoTone";
import { isUsingChrome } from "../../../../helpers/browser.helper";
import ErrorTwoToneIcon from "@material-ui/icons/ErrorTwoTone";
import { toKebabCase } from "../../../../helpers/cssHelper";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { combineProps } from "../../../../helpers/objectHelper";
import { ChatAvatar } from "../../../../digitalArena/modules/ChatModule/components/ChatAvatar";
import { TimeStamp } from "../../../../digitalArena/modules/ChatModule/components/shared/TimeStamp";
import { MessageBubble } from "../../../../digitalArena/modules/ChatModule/components/MessageBubble";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  title: {
    /*         margin: theme.spacing(4, 0, 2), */
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    /*       padding: theme.spacing(3), */
  },
}));
const OnlineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const AwayBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#ffc107",
    color: "#ffc107",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}))(Badge);

export default class ExpoChat extends React.Component {
  state = {
    currentChat: null,
  };
  componentDidUpdate(prevProps) {
    if (this.props.chat && this.props.targetPerson && this.state.currentChat == null) {
      const host = this.props.exhibitorHosts.find((o) => o.badgeNo == this.props.targetPerson);
      if (!host) return;
      this.setState({
        currentChat: { ...this.state.currentChat, target: host },
      });
    }
    if (this.props.chat && prevProps.chat !== this.props.chat && this.state.currentChat != null) {
      const currentChat = this.props.chat.find((c) => c.target == this.state.currentChat.target.badgeNo);
      //refresh he chatmessages on update
      if (currentChat) {
        this.onChatSelect(currentChat);
      }

      //If the current chat has gotten a new message set seen = true
      if (currentChat && this.state.currentChat && currentChat.target == this.state.currentChat.target.badgeNo) {
        let unseenMessage = this.props.chat.find((c) => c.messages.find((m) => m.seen == false) && c.target == this.state.currentChat.target.badgeNo);
        if (unseenMessage) this.props.setMessageSeen(unseenMessage);
      }
      //if you init a chat set it to the currentchat
      const hasNewInits = this.props.chat.find((c) => c.messages.find((m) => m.message === "INIT" && m.sender == this.props.clientKey));
      const prevHasNewInits = prevProps.chat.find((c) => c.messages.find((m) => m.message === "INIT" && m.sender == this.props.clientKey));
      if (hasNewInits && !prevHasNewInits) {
        this.onChatSelect(hasNewInits);
      }
    }
    if (
      this.props.selectedChat &&
      this.props.selectedChat != prevProps.selectedChat &&
      (!this.state.currentChat || (this.state.currentChat && this.state.currentChat.target != this.props.selectedChat))
    ) {
      this.onChatSelect(this.props.selectedChat);
    }
  }
  onChatSelect = (target, seen = true) => {
    if (target == "DESELECT") {
      this.props.selectChat(null);
      return this.setState({ currentChat: null });
    }
    const { exhibitorHosts, clientName, chat } = this.props;
    let currentChat = chat.find((c) => c.target == target);
    let missedGroupMessages = this.state.missedGroupMessages;
    if (!currentChat)
      currentChat = {
        lastChange: "",
        messages: [],
        previewText: "",
        previewPreFix: "",
        target: target,
        seen: true,
      };
    if (seen == false) {
      this.props.setMessageSeen(currentChat);
    }

    const host = exhibitorHosts.find((o) => o.badgeNo == target);
    if (!host) return;
    this.props.selectChat(host);
    this.setState({ currentChat: { ...this.state.currentChat, target: host } });
  };

  render() {
    return <ChatDivider {...this.props} currentChat={this.state.currentChat} onChatSelect={this.onChatSelect} />;
  }
}

function ChatDivider(props) {
  const { window, tab, exhibitorHosts, chat, anonymous, connectionList, clientKey, videoCallActive, videoCallTarget, closeVideoCall, videoRequest, nonAvailablePersons, enableChat, template, lang } =
    props;

  const classes = useStyles();
  const theme = useTheme();
  let isChrome = isUsingChrome();

  let formattedExpoList = exhibitorHosts.filter((eh) => connectionList.find((c) => c.clientKey == eh.badgeNo));
  formattedExpoList = [...formattedExpoList, ...exhibitorHosts.filter((eh) => !formattedExpoList.find((c) => c.badgeNo == eh.badgeNo))];

  const formatPeopleList = () =>
  formattedExpoList.map((eh, i) => {
      /*        if (exhibitorHosts.find(e => e.badgeNo == clientKey)) return; */

      const c = chat.find((c) => c.target == eh.badgeNo);
      let seenCondition = (c && !c.seen && c.messages[c.messages.length - 1].sender != clientKey) || (c && (!c.seen || c.messages.find((m) => m.seen == false && m.sender != clientKey)));
      let onPressFunc = () => props.onChatSelect(eh.badgeNo, !seenCondition);
      /*    if (videoCallTarget) return <VideoFrame targetPerson={exhibitorHosts.find(eh => eh.badgeNo == videoCallTarget).name} displayName={props.clientName} {...props} /> */
      if (exhibitorHosts.find((e) => e.badgeNo == clientKey)) {
        onPressFunc = () => null;
      }
      return (
        <div
          key={i}
          className="smooth-shadow"
          style={{
            /*   marginLeft: 10,
              marginRight: 21, */
            borderRadius: 10,
            /*     border: '1px solid #dcdcdc33', */
            margin: "3px 10px",
          }}
        >
          {/* <ListItem className="chat-list-item " onClick={() => onPressFunc()} style={{ backgroundColor: props.currentChat && eh.badgeNo == props.currentChat.target.badgeNo ? '#edf4ff' : undefined }} alignItems="flex-start" > */}
          <ListItem style={{ paddingLeft: 26 }}>
            {seenCondition ? (
              <div className="notice-dot" onClick={() => onPressFunc()} style={{ marginTop: "3px" }}>
                <div className="dot"></div>
              </div>
            ) : null}
            <Tooltip
              title={
                <React.Fragment>
                  <Typography
                    style={{
                      fontSize: 14,
                      fontWeight: "bold",
                      fontFamily: template ? template.text.fontFamily : undefined,
                    }}
                  >
                    {eh.name}
                  </Typography>
                  <Typography variant="p" style={{ textAlign: "center" }}>
                    {!exhibitorHosts.find((e) => e.badgeNo == clientKey) ? (
                      <EventLabel2 name="ChatWithMe" groupName="Exhibitor.Booth" />
                    ) : (
                      <SystemLabel name="YouCanNotChatWithHostsAsHost" languageCode={lang} />
                    )}
                  </Typography>
                </React.Fragment>
              }
              aria-label="add"
            >
              <div>
                <ChatAvatar
                  {...combineProps([
                    props,
                    {
                      connectionList,
                      orderList: exhibitorHosts,
                      primaryColor: "#e4e6eb",
                      secondaryColor: "#fff",
                      target: eh.badgeNo,
                    },
                  ])}
                >
                  <PersonRoundedIcon />
                </ChatAvatar>
              </div>
            </Tooltip>
            <ListItemText
              style={{ marginLeft: 10 }}
              primary={
                <span
                  style={{
                    fontFamily: template ? template.text.fontFamily : undefined,
                    color: "#222",
                  }}
                >
                  {eh.name}
                </span>
              }
              secondary={
                <span
                  style={{
                    fontFamily: template ? template.text.fontFamily : undefined,
                    color: "gray",
                  }}
                >
                  {connectionList.find((cl) => cl.clientKey == eh.badgeNo) ? <EventLabel2 name="IsOnline" groupName="Exhibitor.Booth" /> : <EventLabel2 name="IsOffline" groupName="Exhibitor.Booth" />}
                </span>
              }
            />

            {!exhibitorHosts.find((e) => e.badgeNo == clientKey) ? (
              <div>
                {enableChat && anonymous != true ? (
                  <Button
                    onClick={() => onPressFunc()}
                    disabled={exhibitorHosts.find((e) => e.badgeNo == clientKey)}
                    startIcon={<QuestionAnswerTwoToneIcon />}
                    style={{
                      border: "1px solid gainsboro",
                      color: "#585858",
                      padding: "7px 16px",
                      fontFamily: template ? template.button.fontFamily : undefined,
                      textTransform: "capitalize",
                      marginRight: 5,
                      cursor: "pointer",
                    }}
                  >
                    <EventLabel2 name="Messages" groupName="Exhibitor.Booth" />
                  </Button>
                ) : null}
                {!isChrome ? (
                  <Tooltip title={<SystemLabel name="YouNeedGoogleChromeForVideoMeetings" languageCode={lang} />}>
                    <div className="chrome-warning">
                      <ErrorTwoToneIcon />
                    </div>
                  </Tooltip>
                ) : null}
                {props.enableVideoMeeting && anonymous != true ? (
                  <Button
                    disabled={nonAvailablePersons.includes(eh.badgeNo) || !isChrome || !connectionList.find((cl) => cl.clientKey == eh.badgeNo) || exhibitorHosts.find((e) => e.badgeNo == clientKey)}
                    onClick={() => videoRequest(eh.badgeNo)}
                    startIcon={nonAvailablePersons.includes(eh.badgeNo) && connectionList.find((cl) => cl.clientKey == eh.badgeNo) ? <VideocamOffTwoToneIcon /> : null}
                    style={{
                      border: "1px solid " + (nonAvailablePersons.includes(eh.badgeNo) ? "ff0000d6" : "gainsboro"),
                      color: nonAvailablePersons.includes(eh.badgeNo) ? "#ff0000d6" : "#585858",
                      padding: "7px 16px",
                      cursor: "pointer",
                      textTransform: "capitalize",
                      marginRight: 5,
                    }}
                  >
                    {!connectionList.find((cl) => cl.clientKey == eh.badgeNo) ? <VideocamOffTwoToneIcon /> : null}
                    {!nonAvailablePersons.includes(eh.badgeNo) && connectionList.find((cl) => cl.clientKey == eh.badgeNo) ? <VideocamTwoToneIcon /> : null}
                    {nonAvailablePersons.includes(eh.badgeNo) ? <EventLabel2 name="Busy" groupName="Exhibitor.Booth" /> : null}
                  </Button>
                ) : null}
              </div>
            ) : null}
            <br />
          </ListItem>
          {eh.profileBio ? (
            <div
              style={{
                paddingLeft: "35px",
                marginTop: "-8px",
                fontFamily: template ? template.text.fontFamily : undefined,
                paddingBottom: "10px",
                color: "gray",
              }}
            >
              <em>{eh.profileBio}</em>
            </div>
          ) : null}
        </div>
      );
    });
  return (
    <div>
      {props.currentChat ? (
        <div style={{ height: "100%", overflowY: "auto" }}>
          {" "}
          <ChatGrid
            chat={props.chat}
            scroll={props.scroll}
            deselectChat={() => props.onChatSelect("DESELECT")}
            clientKey={props.clientKey}
            exhibitorHosts={props.exhibitorHosts}
            currentChat={props.currentChat}
            sendMessage={props.sendMessage}
            connectionList={props.connectionList}
            like={props.like}
            {...props}
          />
        </div>
      ) : (
        <div style={{ height: "100%", overflowY: "auto" }}>
          {" "}
          <div
            style={
              template
                ? {
                    fontFamily: template.subtitle.fontFamily,
                    textAlign: "left",
                    color: "#222",
                    paddingLeft: 23,
                    paddingTop: 20,
                    paddingBottom: 15,
                    fontSize: 18,
                  }
                : {
                    color: "#222",
                    fontSize: 18,
                    textAlign: "left",
                    paddingLeft: 23,
                    paddingTop: 10,
                    paddingBottom: 15,
                  }
            }
          >
            <EventLabel2 name="Exhibitors" groupName="Exhibitor.Booth" />
          </div>{" "}
          <style>{template ? `${toKebabCase(template.scrollbar, true, true)}` : ""}</style>
          <div className="jir-scroll" style={{ maxHeight: "calc(45vh - 83px)", overflow: "auto" }}>
            {formatPeopleList()}
          </div>
        </div>
      )}
    </div>
  );
}

class ChatGrid extends React.Component {
  state = {
    messages: [],
    text: "",
    size: 1,
    loaded: false,
  };
  componentDidMount() {
    document.addEventListener("keyup", this.onEnter);
    this.handleScroll();
  }
  onEnter = (e) => {
    var e = e || window.event; // for IE to cover IEs window event-object
    if (e.which == 13 && this.state.text) {
      this.sendMessage();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.scroll && !prevProps.scroll) {
      this.handleScroll();
    }
    if (this.props.currentChat != prevProps.currentChat) {
      this.handleScroll();
    }
  }
  setChatSize = (size) => {
    localStorage.setItem("CHAT_SIZE", size);
    this.setState({ size });
  };

  handleScroll = (id) => {
    const { currentChat, chat } = this.props;
    if (currentChat && currentChat.target) {
      let chatIndex = chat.indexOf(chat.find((c) => c.target == currentChat.target.badgeNo));
      if (chatIndex > -1) {
        let index = chat[chatIndex].messages.length - 1;
        if (index > -1 && this.refs[index] !== undefined) {
          try {
            this.refs[index].scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            this.setState({ loaded: false });
          } catch (error) {
            console.error(error);
          }
        }
      }
    }
  };
  sendMessage = () => {
    const { currentChat, connectionList } = this.props;
    const { text } = this.state;
    const { target } = currentChat;
    this.props.sendMessage(target, text);
    this.setState({ text: "" });
  };

  renderTargetCard = () => {
    const { currentChat, connectionList, template } = this.props;
    const { target } = currentChat;
    return (
      <ListItem alignItems="flex-start" style={{ paddingLeft: 24 }}>
        <ListItemAvatar>
          <ChatAvatar
            {...combineProps([
              this.props,
              {
                connectionList,
                orderList: this.props.exhibitorHosts,
                primaryColor: "#e4e6eb",
                secondaryColor: "#fff",
                target: target.badgeNo,
              },
            ])}
          >
            <PersonRoundedIcon />
          </ChatAvatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <span
              style={{
                fontFamily: template ? template.text.fontFamily : undefined,
                fontWeight: "bold",
                color: "#5e5e5e",
              }}
            >
              {target.name}
            </span>
          }
          secondary={
            <span
              style={{
                fontFamily: template ? template.text.fontFamily : undefined,
                color: "#5e5e5e",
              }}
            >
              {connectionList.find((cl) => cl.clientKey == target.badgeNo) ? <EventLabel2 name="IsOnline" groupName="Exhibitor.Booth" /> : <EventLabel2 name="IsOffline" groupName="Exhibitor.Booth" />}
            </span>
          }
        />
        <ListItemSecondaryAction>
          {target.linkedIn ? (
            <IconButton style={{ marginTop: 20 }} onClick={() => window.open(target.linkedIn, "_blank")}>
              <LinkedInIcon style={{ color: "#2867B2", fontSize: 35 }} />
            </IconButton>
          ) : null}
          <IconButton style={{ marginTop: 20 }} onClick={this.props.deselectChat}>
            <CloseTwoToneIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  render() {
    const { currentChat, exhibitorHost, chat, like = () => null, template, lang, connectionList, clientKey, profile } = this.props;
    if (!currentChat) return null;
    return (
      <div className="chat-container" style={{ border: "0px" /* , marginRight: 15 */ }}>
        <AppBar
          position="static"
          style={{
            backgroundColor: "#fff",
            boxShadow: "none",
            marginTop: "-18px",
            borderBottom: "1px solid gainsboro",
          }}
        >
          {this.renderTargetCard()}
        </AppBar>
        <style>{template ? `${toKebabCase(template.scrollbar, true, true)}` : ""}</style>
        <div
          className="conversation jir-scroll"
          style={{
            minHeight: "calc(45vh - 114px)",
            maxHeight: "calc(45vh - 114px)",
            overflowY: "auto",
            backgroundColor: "transparent",
          }}
        >
          {currentChat.target && chat.find((c) => c.target == currentChat.target.badgeNo)
            ? chat
                .find((c) => c.target == currentChat.target.badgeNo)
                .messages.map((m, i) => {
                  if (m.message == "INIT") return null;
                  const cc = chat.find((c) => c.target == currentChat.target.badgeNo).messages;
                  return (
                    <React.Fragment key={i}>
                      {i != 0 && !isTheSameMinute(m.inserted, chat.find((c) => c.target == currentChat.target.badgeNo).messages[i - 1].inserted) ? (
                        <TimeStamp
                          {...combineProps([
                            {
                              messages: {},
                              color: "#222",
                              timeStamp: m.inserted,
                              lang,
                            },
                          ])}
                        />
                      ) : null}
                      <div
                        ref={i}
                        key={i}
                        className="c-box-da"
                        style={{
                          padding: "0px 20px",
                          flexDirection: m.sender == clientKey ? "row-reverse" : undefined,
                        }}
                      >
                        <div className="chat-avatar-wrapper">
                          <ChatAvatar
                            {...combineProps([
                              this.props,
                              {
                                target: m.sender,
                                connectionList,
                                orderList: [...this.props.exhibitorHosts, { ...profile, badgeNo: clientKey }],
                                primaryColor: "#e4e6eb",
                                secondaryColor: "#fff",
                              },
                            ])}
                          >
                            <PersonRoundedIcon />
                          </ChatAvatar>
                        </div>

                        <MessageBubble
                          {...combineProps([
                            { ...m, timeStamp: m.inserted },
                            this.props,
                            {
                              size: this.state.size,
                              message: m.message,
                              id: m.interactionChatId,
                              namee: m.name,
                              likes: m.likes,
                              onLike: (id) => like(id, currentChat.target.badgeNo),

                              chatTemplate: {
                                messages: {
                                  fontSize: "15px",
                                  fontWeight: "initial",
                                  lineHeight: "auto",
                                  fontFamily: "Open Sans",
                                  color: "initial",
                                  receiver: {
                                    backgroundColor: "#e4e6eb",
                                    color: "#050505",
                                  },
                                  sender: {
                                    backgroundColor: "#5a60e3",
                                    color: "#fff",
                                  },
                                },
                              },
                              fromYou: m.sender == clientKey,
                            },
                          ])}
                        />
                      </div>
                    </React.Fragment>
                  );
                })
            : null}
        </div>
        <div className="text-bar" style={{ paddingRight: 5 }}>
          <div className="text-bar__field">
            <input className="chat-input" placeholder={renderText("TypeSomething", "Exhibitor.Booth")} type="text" value={this.state.text} onChange={(e) => this.setState({ text: e.target.value })} />
          </div>
          <div className="text-bar__thumb">
            <IconButton disabled={!this.state.text} onClick={this.sendMessage}>
              <Tooltip title={<EventLabel2 name="SendMessageToolTip" groupName="Exhibitor.Booth" />}>
                <SendIcon />
              </Tooltip>
            </IconButton>
            <IconButton
              style={{ color: "#5a60e3" }}
              onClick={() => {
                this.setState({ text: "THUMB_UP" }, () => this.sendMessage());
              }}
            >
              <Tooltip title={<EventLabel2 name="ThumbUpToolTip" groupName="Exhibitor.Booth" />}>
                <ThumbUpIcon />
              </Tooltip>
            </IconButton>
          </div>
        </div>
      </div>
    );
  }
}
